<template>
<v-bottom-sheet inset v-model="isVisible">
    <v-sheet class="text-center">
        <div class="pa-3" style="background: #f0f0f0">
            <v-btn color="primary" @click="buy">
                매수
            </v-btn>
            <v-btn color="red" @click="isVisible = false">
                취소
            </v-btn>
        </div>
        <div class="py-3">
            <b>{{ item.name }}</b>
            <div>1주 당 {{ priceString }} 원</div>
            <v-row justify="center" align="center">
                <v-btn text @click="minusCount">
                    <v-icon>remove</v-icon>
                </v-btn>
                <v-col cols="3">
                    <v-text-field class="centered-input" solo hide-details v-model="count" type="number" suffix="주" @input="count = Math.floor($event)" />
                </v-col>
                <v-btn text @click="count++">
                    <v-icon>add</v-icon>
                </v-btn>
            </v-row>

            <div>거래금액: {{ totalPrice }} 원</div>
            <div>잔액: {{ cashString }} 원</div>
        </div>
    </v-sheet>
</v-bottom-sheet>
</template>

<script>
export default {
    name: 'buy-dialog',
    props: ['cash'],
    data() {
        return {
            isVisible: false,
            item: '',
            count: 0
        }
    },
    computed: {
        priceString() {
            return `${this.item.price}`.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
        },
        cashString() {
            return `${Math.floor(this.cash)}`.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
        },
        totalPrice() {
            return `${this.count * this.item.price}`.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
        }
    },
    methods: {
        show(item) {
            this.count = 0
            this.item = item
            this.isVisible = true
        },
        minusCount() {
            if (this.count <= 0) return

            this.count--
        },
        buy() {
            if (this.count == 0) return

            if (this.count * this.item.price > this.cash) return this.$toasted.error('잔액이 부족합니다')

            if (!confirm('정말 매수하시겠습니까?')) return

            this.$emit('buy', {
                code: this.item.code,
                name: this.item.name,
                count: this.count,
                price: this.item.price,
                total: this.count * this.item.price
            })

            this.isVisible = false
        },
    }
}
</script>
